module.exports = __webpack_public_path__ + "assets/img/829552dfb9bba338c658d56b3a08e0cb.svg";